<template>
  <div id="app">
    <div class="header">
      <van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <div style="background-color: #f5f5f5;height: 100vh;padding-top: 30px">
        <van-cell-group inset>
          <van-field
              v-model="message"
              rows="2"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="请输入反馈内容，我们会为您更好的服务"
              show-word-limit
          />
        </van-cell-group>
      <van-button round block type="primary" native-type="submit" @click="submitFeed">
        提交
      </van-button>
    </div>
  </div>
</template>

<script>

import {opinion} from "../common/api/feed";
import jump from "../common/jump";

export default {
  name: "feed",
  data(){
    return{
      message:'',
      content:[]
    }
  },
  methods:{

    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    submitFeed(){
      opinion({advice:this.message}).then(res => {
        console.log(res)
        this.$toast.success(res.msg)
        this.message = ''
      })
    }
  }
}
</script>

<style scoped>
.van-cell{
  border-radius: 10px;
  padding:20px
}
/deep/ .van-field__control{
  height: 120px !important;
}
.van-button--round{
  width: 90%;
  background-color: #0f72dd;
  margin: 50px auto;
}
</style>